import { t } from "@lingui/macro";
import { CommonActions } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ImageBackground } from "react-native";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { useBreakpointValue } from "@whoosh/design-system/src/hooks/useBreakpointValue";
import { images } from "@whoosh/design-system/src/theme/images";

import { BaseNavigatorParamList } from "../../navigators/BaseNavigator/types";

export const NotFoundScreen = ({
  navigation,
  route,
}: NativeStackScreenProps<BaseNavigatorParamList, "NotFound">) => {
  const isMobileLayout = useBreakpointValue({
    base: true,
    md: false,
  });
  return (
    <ImageBackground
      source={
        isMobileLayout
          ? images.initialBackground
          : images.desktopLandingBackground
      }
      resizeMode="cover"
      style={{ flex: 1 }}
    >
      <Box
        alignItems="center"
        justifyContent="center"
        height="100%"
        width="100%"
      >
        <Text
          accessibilityRole="header"
          variant="mainTitle3"
          maxFontSizeMultiplier={2}
          color="grayscale-0"
          mb={5}
        >{t`Whoops! That didn't work.`}</Text>
        <Button
          onPress={() => {
            navigation.dispatch(
              CommonActions.reset({
                index: 0,
                routes: [{ name: "Unauthenticated" }],
              })
            );
          }}
          accessibilityLabel={t`Try Again button`}
        >{t`Try Again`}</Button>
      </Box>
    </ImageBackground>
  );
};
